const LS_KEY = 'booking_otp_session';

export const setOtpSession = (mobile, sessionId) => {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify({ mobile, sessionId }));
  } catch {
    // Storage unavailable — silent fail.
  }
};

export const getOtpSession = (mobile) => {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return null;
    const { mobile: savedMobile, sessionId } = JSON.parse(raw);
    return savedMobile === mobile && sessionId ? sessionId : null;
  } catch {
    return null;
  }
};

export const clearOtpSession = () => {
  try {
    localStorage.removeItem(LS_KEY);
  } catch {
    // ignore
  }
};
